import styled from 'styled-components/macro';
import media from '../../styles/media';
import { fontSize } from '../../styles/mixins';

export const StaticTextWrapper = styled.section`
  margin: ${({ margin }) => margin};
  ${media.desktop`
    margin: ${({ marginDesktop }) => marginDesktop};
  `};
`;

export const StaticTextText = styled.p`
  color: ${({ color }) => color};
  ${({ size }) => (size ? fontSize(size) : fontSize(10))};
  font-weight: normal;
  font-style: normal;
  line-height: 1.5;
  text-align: ${({ alignLeft }) => (alignLeft ? 'initial' : 'center')};
`;
